import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top on route change
    // Use setTimeout to ensure it happens after route transition
    setTimeout(() => {
      // Reset Lenis scroll position if available
      if (window.lenis) {
        window.lenis.scrollTo(0, { immediate: true });
      }
      
      // Also use native scroll as backup
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    }, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
